import React, { useState } from 'react';

import type { Theme } from '@mui/material';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'UserRole' is defined but never used.
import classNames from 'classnames';

import VideaLogo from '../../../common-components/elements/icon/svgs/VideaLogo';
import { colors } from '../../../utils/theme';

import { useRotation } from './RotationContext';

const useStyles = makeStyles((theme: Theme) => ({
  saveAndRerunButton: {
    backgroundColor: colors.PRIMARY,
    padding: 3,
    textTransform: 'none',
    height: 32,
    width: 100,
    color: 'white',
    '&:hover': {
      backgroundColor: 'white',
      color: colors.PRIMARY,
    },
    marginRight: theme.spacing(2),
  },
}));

const RerunAiButton: React.FC<{
  className?: string;
  currentImage?: any;
}> = ({ className, currentImage }) => {
  const classes = useStyles();
  const [isHoveringRerunButton, setIsHoveringRerunButton] = useState(false);
  const { saveAndRerunAi, isLoadingRerun } = useRotation();

  // if (isPreventedFromRotating) {
  //   return null;
  // }

  return (
    <Button
      variant="contained"
      className={classNames(classes.saveAndRerunButton, 'vai-flex', className)}
      onClick={() => saveAndRerunAi(currentImage)}
      disabled={isLoadingRerun}
      onMouseEnter={() => setIsHoveringRerunButton(true)}
      onMouseLeave={() => setIsHoveringRerunButton(false)}
      startIcon={
        !isLoadingRerun && (
          <VideaLogo color={isHoveringRerunButton ? colors.PRIMARY : 'white'} />
        )
      }
      
    >
      Rerun AI
    </Button>
  );
};

export default RerunAiButton;
